import { Suspense, useEffect } from 'react';
import { Outlet } from 'react-router';
import { ThemeProvider } from '@/lib/components/theme-provider';
import { Toaster } from '@/components/ui/toaster';

import Loader from '../components/Loader';
import Sidebar from './Sidebar';
import Meta from './Meta';

const Layout = () => {
  useEffect(() => {
    // this is a guard to prevent the user from accessing the dashboard page with a sequence_id
    // this will only apply, if the user types the url manually, without ending the time travel mode
    const sequenceData = sessionStorage.getItem('sequence_id');
    if (sequenceData) {
      sessionStorage.removeItem('sequence_id');
      window.location.reload();
    }
  }, []);

  return (
    <ThemeProvider>
      <Meta />
      <div className="flex flex-col dark:bg-black dark:text-white">
        {/* <Header /> */}
        <Sidebar />
        <div className="flex flex-col pl-[20vw]">
          <main className="wrapper ml-0 w-full max-w-full">
            {/* TODO: See if shads class "wrapper" is better */}
            {/* TODO: Add fallback component */}
            <Suspense fallback={<Loader />}>
              <Outlet />
            </Suspense>
          </main>
          <Toaster />
        </div>
      </div>
    </ThemeProvider>
  );
};

export default Layout;
